import {useQuery} from "@tanstack/react-query";
import {fetchDELETE, fetchGET, fetchPOST, fetchPUT} from "./fetch";
import {useMyMutation} from "./mymutation";

const REACT_QUERY_ID_DMODELS = "dmodels";
const BASE_URL = "/api/dmodels";

const DmodelsQueryConfig = {
    staleTime: 0,
    cacheTime: 1000 * 60 * 5,
}

export const DMODELS_EMPTY = {
    provincie:"",
    provincieNr:"",
    gestichtIn:"",
    url:"",
    email:"",
    eigenaar:"",
    rekeningNr:"",
    opNaamVan:"",
    naamProvincieLokaal:"",
    adres:"",
    telefoon:"",
    gsm:"",
    fax:"",


    naamVoorzitter:"",
    voornaamVoorzitter:"",
    straatVoorzitter:"",
    nrVoorzitter:"",
    postcodeVoorzitter:"",
    gemeenteVoorzitter:"",
    telVoorzitter:"",
    gsmVoorzitter:"",
    faxVoorzitter:"",
    emailVoorzitter:"",


    naamOnderVoorzitter:"",
    voornaamOnderVoorzitter:"",
    straatOnderVoorzitter:"",
    nrOnderVoorzitter:"",
    postcodeOnderVoorzitter:"",
    gemeenteOnderVoorzitter:"",
    telOnderVoorzitter:"",
    gsmOnderVoorzitter:"",
    faxOnderVoorzitter:"",
    emailOnderVoorzitter:"",


    naamSecretaris:"",
    voornaamSecretaris:"",
    straatSecretaris:"",
    nrSecretaris:"",
    postcodeSecretaris:"",
    gemeenteSecretaris:"",
    telSecretaris:"",
    gsmSecretaris:"",
    faxSecretaris:"",
    emailSecretaris:"",


    naamPenning:"",
    voornaamPenning:"",
    straatPenning:"",
    nrPenning:"",
    postcodePenning:"",
    gemeentePenning:"",
    telPenning:"",
    gsmPenning:"",
    faxPenning:"",
    emailPenning:"",


    naamRaadsman:"",
    voornaamRaadsman:"",
    straatRaadsman:"",
    nrRaadsman:"",
    postcodeRaadsman:"",
    gemeenteRaadsman:"",
    telRaadsman:"",
    gsmRaadsman:"",
    faxRaadsman:"",
    emailRaadsman:"",


    naamRaadslid1:"",
    voornaamRaadslid1:"",
    straatRaadslid1:"",
    nrRaadslid1:"",
    postcodeRaadslid1:"",
    gemeenteRaadslid1:"",
    telRaadslid1:"",
    gsmRaadslid1:"",
    faxRaadslid1:"",
    emailRaadslid1:"",


    naamRaadslid2:"",
    voornaamRaadslid2:"",
    straatRaadslid2:"",
    nrRaadslid2:"",
    postcodeRaadslid2:"",
    gemeenteRaadslid2:"",
    telRaadslid2:"",
    gsmRaadslid2:"",
    faxRaadslid2:"",
    emailRaadslid2:"",


    naamRaadslid3:"",
    voornaamRaadslid3:"",
    straatRaadslid3:"",
    nrRaadslid3:"",
    postcodeRaadslid3:"",
    gemeenteRaadslid3:"",
    telRaadslid3:"",
    gsmRaadslid3:"",
    faxRaadslid3:"",
    emailRaadslid3:"",


    naamRaadslid4:"",
    voornaamRaadslid4:"",
    straatRaadslid4:"",
    nrRaadslid4:"",
    postcodeRaadslid4:"",
    gemeenteRaadslid4:"",
    telRaadslid4:"",
    gsmRaadslid4:"",
    faxRaadslid4:"",
    emailRaadslid4:"",


    naamRaadslid5:"",
    voornaamRaadslid5:"",
    straatRaadslid5:"",
    nrRaadslid5:"",
    postcodeRaadslid5:"",
    gemeenteRaadslid5:"",
    telRaadslid5:"",
    gsmRaadslid5:"",
    faxRaadslid5:"",
    emailRaadslid5:"",

    ledenAantal:"",
    datumOpstelling:"",
    verwerkt:""
};

export function useDmodels() {
    const result = useQuery({
        queryKey: [REACT_QUERY_ID_DMODELS],
        queryFn: async () => await fetchGET(BASE_URL),
        //onError: e => setError(e),
        ...DmodelsQueryConfig
    });
    return {...result, dmodels: result.data};
}


export function useDmodel(id) {
    const result = useQuery({
        queryKey: [REACT_QUERY_ID_DMODELS, id],
        queryFn: async () => id ? await fetchGET(`${BASE_URL}/${id}`) : {},
        //onError: e => setError(e),
        ...DmodelsQueryConfig
    });
    return {...result, dmodel: result.data};
}

export function useDmodelMutations() {
    async function createFunction(dmodel) {
        if (!dmodel) return;
        return await fetchPOST(BASE_URL, dmodel, false);
    }

    async function editFunction(dmodel) {
        if (!dmodel) return;
        return await fetchPUT(`${BASE_URL}/${dmodel.id}`, dmodel);
    }

    async function editAddNewFiles(dmodel) {
        if (!dmodel) return;
        return await fetchPUT(`${BASE_URL}/${dmodel.id}/files`, dmodel.fileId);
    }

    async function deleteFunction(dmodel) {
        return await fetchDELETE(`${BASE_URL}/${dmodel.id}`)
    }

    return {
        createDmodel: useMyMutation(createFunction, REACT_QUERY_ID_DMODELS, dmodel => `Dmodel ${dmodel.title} created`),
        editDmodel: useMyMutation(editFunction, REACT_QUERY_ID_DMODELS, dmodel => `Dmodel ${dmodel.title} modified`),
        editAddNewFiles: useMyMutation(editAddNewFiles, REACT_QUERY_ID_DMODELS, dmodel => `Dmodel ${dmodel.title} modified`),
        deleteDmodel: useMyMutation(deleteFunction, REACT_QUERY_ID_DMODELS, dmodel => `Dmodel ${dmodel.title} deleted.`)
    };

}